import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02fcd7fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right-sidebar" }
const _hoisted_2 = {
  key: 0,
  class: "android-seat-top"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_drawer, {
      modelValue: $setup.drawer,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.drawer) = $event)),
      size: "auto",
      "with-header": false,
      "before-close": $setup.close_sidebar
    }, {
      default: _withCtx(() => [
        _createCommentVNode(" 安卓端顶部占位 "),
        ($setup.config.android)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_el_menu, {
          class: "right-sidebar-menu",
          "active-text-color": "#ffd04b",
          "background-color": "#545c64",
          "text-color": "#fff",
          onSelect: $setup.menu_select
        }, {
          default: _withCtx(() => [
            _createCommentVNode("封面"),
            _createElementVNode("img", {
              class: "poster",
              src: $setup.blob,
              alt: "漫画封面"
            }, null, 8 /* PROPS */, _hoisted_3),
            _createCommentVNode("名称"),
            _createElementVNode("p", _hoisted_4, _toDisplayString($setup.chapterName), 1 /* TEXT */),
            _createCommentVNode("操作"),
            _createCommentVNode("<el-menu-item index=\"read\"><el-icon><Memo /></el-icon>阅读</el-menu-item>"),
            _createCommentVNode("<el-menu-item index=\"collection\"><el-icon><Collection /></el-icon>收藏</el-menu-item>"),
            _createVNode(_component_el_menu_item, { index: "delete" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Delete)
                  ]),
                  _: 1 /* STABLE */
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('option.delete')), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}